import Vue from 'vue'
import store from '@/store'
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
const el_scrollBar = (el) => {
  if (el._ps_ instanceof PerfectScrollbar) {
    el._ps_.update()
  } else {
    el._ps_ = new PerfectScrollbar(el, { suppressScrollX: true })
  }
}

Vue.directive('scrollBar', {
  inserted (el) {
    const rules = ['fixed', 'absolute', 'relative']
    if (!rules.includes(window.getComputedStyle(el, null).position)) {
      console.error(`perfect-scrollbar所在的容器的position属性必须是以下之一：${rules.join('、')}`)
    }
    el_scrollBar(el)
  },
  componentUpdated (el, binding, vnode) {
    try {
      vnode.context.$nextTick(
        () => {
          el_scrollBar(el)
        }
      )
    } catch (error) {
      console.error(error)
      el_scrollBar(el)
    }
  }
})

Vue.directive('hasPermi', {
  inserted (el, binding, vnode) {
    const { value } = binding
    const permission = store.state.home.permission
    if (value && value instanceof Array && value.length > 0) {
      permission.map(menu => {
        if (menu.menuName === value[0]) {
          menu.permissions.map(per => {
            if (per.annotation === value[1]) {
              if (per.status === 0) {
                el.parentNode && el.parentNode.removeChild(el)
              }
            }
          })
        }
      })
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
})